module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/fail.js
 ** module id = 67
 ** module chunks = 0
 **/